import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=67ba45b8&scoped=true&"
import script from "./Thumbnail.vue?vue&type=script&lang=js&"
export * from "./Thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=67ba45b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba45b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ba45b8')) {
      api.createRecord('67ba45b8', component.options)
    } else {
      api.reload('67ba45b8', component.options)
    }
    module.hot.accept("./Thumbnail.vue?vue&type=template&id=67ba45b8&scoped=true&", function () {
      api.rerender('67ba45b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/Thumbnail.vue"
export default component.exports